function addHeaders(request: any, options: RequestOptions) {
  const headers = options.headers || {};
  Object.keys(headers).forEach(key => {
    const value = headers[key];
    request.setRequestHeader(key, value);
  });
}

interface RequestOptions {
  data?: any;
  headers?: any;
  method?: 'GET' | 'POST';
  timeout?: number;
  withCredentials?: boolean;
}

function createRequest(url: string, options: RequestOptions) {
  const request = new XMLHttpRequest();
  const { method = 'GET', timeout = 0 } = options;
  request.open(method, url);
  request.timeout = timeout;
  request.withCredentials = options.withCredentials || false;
  addHeaders(request, options);
  return request;
}

function addHandlers(request: any, resolve: any, reject: any) {
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      resolve(request.responseText);
    } else {
      const error = Error(
        request.statusText || 'Unknown failure; possibly CORS'
      ) as any;

      error.status = request.status;
      reject(error);
    }
  };
  request.ontimeout = (e: Error) => {
    if (e && !e.message) {
      e.message = 'Timeout';
    }
    reject(e);
  };
  request.onerror = (e: Error) => {
    reject(e);
  };
}

/// not used yet, commented to be deleted from final output
// function encodeQuery(data: Obj ect) {
//   const urlData = [];

//   for(let key in data) {
//     const value = Array.isArray(data[key]) ? data[key] : [data[key]];
//     value.forEach(v => {
//       urlData.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
//     });
//   }
//   return urlData.join('&');
// }

function load(url: string, options: RequestOptions): Promise<any> {
  const request = createRequest(url, options);

  const promise = new Promise((resolve, reject) => {
    addHandlers(request, resolve, reject);
    request.send(options.data);
  }) as any;

  function headers(executor?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      executor = executor || resolve;
      request.onreadystatechange = function() {
        if (this.readyState === this.HEADERS_RECEIVED) {
          executor(request.getAllResponseHeaders());
        }
      };
      promise.then(resolve);
      promise.catch(reject);
    });
  }

  function json(executor?: any) {
    return new Promise((resolve, reject) => {
      promise
        .then(JSON.parse)
        .then(executor || resolve)
        .catch(reject);
    });
  }

  promise.json = json;
  promise.headers = headers;

  return promise;
}

const ajaxPromises = {
  get(url: string, options: RequestOptions = {}): Promise<any> {
    options.method = 'GET';
    options.data = null;
    return load(url, options);
  },

  /// not used yet, commented to be deleted from final output
  // post(url: string, data: Obj ect, options: Obj ect = {}): Promise<any> {
  //   options.method = 'POST';
  //   options.headers = options.headers || {};
  //   options.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
  //   options.data = encodeQuery(data);
  //   return load(url, options);
  // },

  postJson(
    url: string,
    data: object,
    options: RequestOptions = {}
  ): Promise<any> {
    options.method = 'POST';
    options.headers = options.headers || {};
    options.headers['Content-Type'] = 'application/json; charset=UTF-8';
    options.data = JSON.stringify(data);
    return load(url, options);
  }

  /// not used yet, commented to be deleted from final output
  // head(url: string, options: Ob ject = {}): Promise<any>{
  //   options.method = 'HEAD';
  //   options.data = null;
  //   return load(url, options).headers();
  // },
};

export default ajaxPromises;
